import apiConfig from '../../../../../config/api'
import { apiRequestorHelper } from '../../../../../helpers'

export default {
  items: (type, filters) => {
    return apiRequestorHelper({
  		url: apiConfig.url + '/formsByTypeDeclaration/' + type,
  		method: 'post',
  		body: filters
  	})
  },
  sendReminders: (type, filters, items) => {
    return apiRequestorHelper({
  		url: apiConfig.url + '/sendReminders/' + type,
  		method: 'post',
  		body: { ...filters, items }
  	})
  },
  deleteDeclarations: (type, filters, items) => {
    return apiRequestorHelper({
  		url: apiConfig.url + '/deleteDeclarations/' + type,
  		method: 'post',
  		body: { ...filters, items }
  	})
  },
}
